import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * An item's main photo as a small square at the left edge of a row (0080). Dumb on purpose:
 * no store, no provider — the attachment id arrives in the parent's DTO, and the image URL
 * lives here only. Without a photo the slot stays empty but keeps its size, so columns stay
 * put and rows with and without a picture are one height.
 *
 * `src` is for the one place a photo exists before it is an attachment — the import preview's
 * picture from the sheet (0086) — so it draws through the same square instead of a copy of it.
 */
@Component({
  selector: 'item-photo',
  templateUrl: './item-photo.component.html',
  styleUrl: './item-photo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemPhotoComponent {
  // null as the API sends it — a position frozen without a photo, an item that has none
  readonly attachmentId = input<number | null | undefined>();
  readonly size = input<'row' | 'card' | 'face'>('row');
  readonly label = input<string>('');
  readonly src = input<string>();

  readonly imageSrc = computed(() => {
    const src = this.src();
    const id = this.attachmentId();

    return src ?? (id ? `/api/bom/attachments/${id}/thumbnail` : null);
  });
}
